import React from "react";

import { Box } from "@mui/material";

import { useSidebar } from "@/contexts/SidebarContext";
import rubicon from "@/images/rubicon.png";

export const Copyright: React.FC = () => {
  const { collapsed } = useSidebar();
  const currentYear = new Date().getFullYear();

  return (
    <div className="footer-copyright">
      <a href="https://tryrubicon.com">
        <img src={rubicon} className="rubicon-icon" alt="Rubicon logo" />
      </a>
      {!collapsed && (
        <Box className="copyright-text" sx={{ color: "frame.text.secondary" }}>
          &copy; {currentYear} Made Proudly in North America by Rubicon Inc.
        </Box>
      )}
    </div>
  );
};
